const config = {
    API_URL: process.env.REACT_APP_API_URL || 'https://modernbakery.shop',
};

//  const config = {
//           API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
//       };



     
export default config;
